export default {
  'forgetpassword.forgetpassword': 'パスワードをお忘れですか？',
  'forgetpassword.wrongemail': 'メールが間違っています',
  'forgetpassword.resetemail':
    'パスワードのリセットにはメールアドレスを入力してください',
  'forgetpassword.resetpassword': 'パスワードのリセット',
};
